import * as types from '@/store/mutation-types.js'

// state
export const state = {
  manageUser: {},
  goals: null
}
// mutations
export const mutations = {
  [types.SET_MANAGE_PROFILE] (state, payload) {
    state.manageUser = payload
  },
  [types.CLEAR_MANAGE_GOALS] (state) {
    state.goals = null
  },
  [types.SET_MANAGE_GOALS] (state, payload) {
    state.goals = payload
  }
}
// actions
export const actions = {
  setManageUser ({ commit, state }, payload) {
    commit(types.SET_MANAGE_PROFILE, payload)
  },
  clearManageGoals ({ commit, state }) {
    commit(types.CLEAR_MANAGE_GOALS)
  },
  setManageGoals ({ commit, state }, payload) {
    commit(types.SET_MANAGE_GOALS, payload)
  }
}
// getters
export const getters = {
  manageUser: state => state.manageUser,
  manageGoals: state => state.goals
}



// WEBPACK FOOTER //
// ./src/store/modules/manageUser.js